/**
 * Resolves the API base URL at runtime so the app self-heals when deployed
 * behind a custom domain (e.g. https://restro-pos.com) without needing the
 * frontend rebuilt with a new REACT_APP_BACKEND_URL.
 *
 * Priority:
 *   1. If running on localhost OR on the preview host (*.emergentagent.com),
 *      use REACT_APP_BACKEND_URL exactly as built.
 *   2. Otherwise (custom production domain), prefer the *current origin* —
 *      i.e. call the API on the same hostname as the page itself. This works
 *      when the platform routes /api/* to the backend.
 *   3. As a last fallback, use REACT_APP_BACKEND_URL (which may be stale, but
 *      better than nothing).
 */
const buildUrl = process.env.REACT_APP_BACKEND_URL || '';

function resolveApiBase() {
  if (typeof window === 'undefined') return buildUrl;
  const { protocol, hostname, origin } = window.location;

  const isLocal =
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('192.168.') ||
    hostname.startsWith('10.');
  const isEmergentPreview =
    hostname.endsWith('.emergentagent.com') ||
    hostname.endsWith('.preview.emergentagent.com');

  // On local + preview, the build-time URL is correct
  if (isLocal || isEmergentPreview) return buildUrl || origin;

  // On a custom production domain, always talk to the same origin
  if (protocol === 'https:' || protocol === 'http:') return origin;

  return buildUrl || origin;
}

export const API_URL = resolveApiBase();
export default API_URL;
